import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SettingsService } from 'app/store/settings/settings.service';
import { FeatureSettings } from 'app/store/settings/settings.state';

export const FeatureSettingsResolver: ResolveFn<FeatureSettings | null> = () => inject(SettingsService).loadFeatureSetttings();
